// extracted by mini-css-extract-plugin
export default {"container":"EndFeedback_container__-I336","content":"EndFeedback_content__Twdhp","infobox":"EndFeedback_infobox__BN+rD","list":"EndFeedback_list__tJwAF"};